import { render, staticRenderFns } from "./AdditionalRequirement.view.vue?vue&type=template&id=6954f1b3&"
import script from "./AdditionalRequirement.view.vue?vue&type=script&lang=js&"
export * from "./AdditionalRequirement.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6954f1b3')) {
      api.createRecord('6954f1b3', component.options)
    } else {
      api.reload('6954f1b3', component.options)
    }
    module.hot.accept("./AdditionalRequirement.view.vue?vue&type=template&id=6954f1b3&", function () {
      api.rerender('6954f1b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/update/partials/supplier-requirements/AdditionalRequirement.view.vue"
export default component.exports